import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import ScrollToTop from '../ScrollToTop';

const Layout = () => {
  return (
    <div className="relative dark:bg-gray-900">
      <ScrollToTop />
      <Header />
      <main className="min-h-screen pt-[120px] lg:pt-[150px]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
